import { useQuery } from "@tanstack/react-query";
import { getExpenses } from "api/expense.api";

/**
 * Outstanding purchase documents for a vendor (balanceDue > 0, not paid/void),
 * used to allocate a payment across specific bills.
 */
export const useGetVendorOpenBills = (vendorId) => {
  return useQuery({
    queryKey: ["vendor-open-bills", vendorId],
    enabled: !!vendorId,
    queryFn: async () => {
      const data = await getExpenses({ vendorId });
      return (data?.documents || [])
        .filter(
          (d) =>
            Number(d.balanceDue) > 0 && !["PAID", "VOID"].includes(d.status),
        )
        .sort((a, b) => new Date(a.documentDate) - new Date(b.documentDate));
    },
    staleTime: 30 * 1000,
  });
};
